const DROP_MARKER = { __dropMarker__: __filename }

export default DROP_MARKER
